module.exports = __webpack_public_path__ + "static/media/doctor.7aba9dfd.png";